export default "__VITE_ASSET__BU15AYB1__"